module.exports = __webpack_public_path__ + "media/images/Camp fire and fir tree-c9e65ef4.webp";